<template>
    <div>
        <p class="mb-md-4 h5">2. Capture la siguiente informaci&oacute;n:</p>
        <br>
        <form>
            <div class="form-group row">
                <label class="col-lg-2 col-md-2 col-sm-12 col-xs-12 col-form-label col-form-label-lg">RFC</label>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <input ref="txtrfc" v-model.trim="form.rfc" @keyup="toUppercase" @blur="searchClient"
                           @keyup.enter="searchClient" type="text"
                           class="form-control form-control-lg" :class="{'border-danger':errRfc}" required>
                </div>
                <!--<div class="col-4">-->
                <!--<button @click.prevent="searchClient" @blur="searchClient" class="btn btn-primary btn-block btn-lg"><b>Buscar</b>-->
                <!--</button>-->
                <!--</div>-->
            </div>
            <div>
                <div class="form-group row">
                    <label class="col-lg-2 col-md-2 col-sm-12 col-xs-12 col-form-label col-form-label-lg">Nombre</label>
                    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                        <input ref="txtnomcli" v-model="form.nomcli" @keyup="nomcliToUppercase" type="text" class="form-control form-control-lg" :class="{'border-danger':errNomcli}" required>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-lg-2 col-md-2 col-sm-12 col-xs-12 col-form-label col-form-label-lg">C&oacute;digo Postal</label>
                    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                        <input ref="txtcp" v-model="form.cp" type="text" class="form-control form-control-lg" :class="{'border-danger':errCp}"
                               required>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-lg-2 col-md-2 col-sm-12 col-xs-12 col-form-label col-form-label-lg">Reg&iacute;men Fiscal</label>
                    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                        <select ref="sltregimen" v-model="form.regimen" :class="{'border-danger':errRegimen}" class="form-control form-control-lg" 
                                required>
                            <option disabled value="">Seleccione Reg&iacute;men Fiscal</option>
                            <option value="601">601	- General de Ley Personas Morales</option>
                            <option value="603">603	- Personas Morales con Fines no Lucrativos</option>
                            <option value="605">605	- Sueldos y Salarios e Ingresos Asimilados a Salarios</option>
                            <option value="606">606	- Arrendamiento</option>
                            <option value="607">607	- Régimen de Enajenación o Adquisición de Bienes</option>
                            <option value="608">608	- Demás ingresos</option>
                            <option value="609">609	- Consolidación</option>
                            <option value="610">610	- Residentes en el Extranjero sin Establecimiento Permanente en México</option>
                            <option value="611">611	- Ingresos por Dividendos (socios y accionistas)</option>
                            <option value="612">612	- Personas Físicas con Actividades Empresariales y Profesionales</option>
                            <option value="614">614	- Ingresos por intereses</option>
                            <option value="615">615	- Régimen de los ingresos por obtención de premios</option>
                            <option value="616">616	- Sin obligaciones fiscales</option>
                            <option value="620">620	- Sociedades Cooperativas de Producción que optan por diferir sus ingresos</option>
                            <option value="621">621	- Incorporación Fiscal (RIF)</option>
                            <option value="622">622	- Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras</option>
                            <option value="623">623	- Opcional para Grupos de Sociedades</option>
                            <option value="624">624	- Coordinados</option>
                            <option value="625">625	- Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas</option>
                            <option value="626">626	- Régimen Simplificado de Confianza</option>
                            <option value="628">628	- Hidrocarburos</option>
                            <option value="629">629	- De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales</option>
                            <option value="630">630	- Enajenación de acciones en bolsa de valores</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-lg-2 col-md-2 col-sm-12 col-xs-12 col-form-label col-form-label-lg">Uso del
                        CDFI</label>
                    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                        <select ref="sltuso" v-model="form.uso" class="form-control form-control-lg" :class="{'border-danger':errUso}"
                                required>
                            <option disabled value="">Seleccione Uso de CFDI</option>
                            <option value="G01">G01 - Adquisición de mercancias</option>
                            <option value="G02">G02 - Devoluciones, descuentos o bonificaciones</option>
                            <option value="G03">G03 - Gastos en general</option>
                            <option value="I01">I01 - Construcciones</option>
                            <option value="I02">I02 - Mobilario y equipo de oficina por inversiones</option>
                            <option value="I03">I03 - Equipo de transporte</option>
                            <option value="I04">I04 - Equipo de computo y accesorios</option>
                            <option value="I05">I05 - Dados, troqueles, moldes, matrices y herramental</option>
                            <option value="I06">I06 - Comunicaciones telefónicas</option>
                            <option value="I07">I07 - Comunicaciones satelitales</option>
                            <option value="I08">I08 - Otra maquinaria y equipo</option>
                            <option value="D01">D01 - Honorarios médicos, dentales y gastos hospitalarios</option>
                            <option value="D02">D02 - Gastos médicos por incapacidad o discapacidad</option>
                            <option value="D03">D03 - Gastos funerales.</option>
                            <option value="D04">D04 - Donativos</option>
                            <option value="D05">D05 - Intereses reales efectivamente pagados por créditos hipotecarios
                                (casa habitación)
                            </option>
                            <option value="D06">D06 - Aportaciones voluntarias al SAR</option>
                            <option value="D07">D07 - Primas por seguros de gastos médicos</option>
                            <option value="D08">D08 - Gastos de transportación escolar obligatoria</option>
                            <option value="D09">D09 - Depósitos en cuentas para el ahorro, primas que tengan como base
                                planes de pensiones
                            </option>
                            <option value="D10">D10 - Pagos por servicios educativos (colegiaturas)</option>
                            <option value="S01">S01 - Sin efectos fiscales</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-lg-2 col-md-2 col-sm-12 col-xs-12 col-form-label col-form-label-lg">Correo</label>
                    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                        <input ref="txtemail" v-model="form.email" @keyup.enter="saveClient" type="email"
                               class="form-control form-control-lg" :class="{'border-danger':errEmail}" required>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <router-link tag="a" :to="{ name: 'SearchNote' }" class="btn btn-light border btn-block btn-lg mb-2">
                        <b>Anterior</b>
                    </router-link>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <a href="#" class="btn btn-custom btn-block btn-lg" @click.prevent="saveClient"><b>Siguiente</b>
                    </a>
                </div>
            </div>
        </form>
        <b-modal id="modalListClients" centered scrollable size="lg" hide-footer>
            <template v-slot:modal-header="{ close }">
                <div>
                    <h5>Seleccione Cliente</h5>
                    <small class="my-2 text-muted">HAGA <b>CLIC</b> SOBRE EL CLIENTE QUE
                        DESEA O HAGA <b>CLIC</b> EN
                    </small>
                    <a href="#" class="btn btn-sm btn-success" @click.prevent="addNameClient()"> Registrar Nuevo Cliente</a>
                </div>
                <a href="#" @click.prevent="close()">
                    <b-icon icon="x" class="text-dark" font-scale="1.5"></b-icon>
                </a>
            </template>

            <template v-slot:default>
                <div class="border">
                    <div v-for="c in client" :key="c.numcli">
                        <div @click.prevent="loadData(c,true)" class="border-bottom p-2 client-pointer" v-if="c.numcli">
                            <div v-if="c.nomcli === '' && c.calle ==='' ">
                                <span> - </span>
                            </div>
                            <div v-else>
                                <b>{{c.nomcli}}</b><span v-if="c.calle"> - {{c.calle}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {session} from "@/utils/session"

    export default {
        name: 'SearchClient',
        data() {
            return {
                isNewClient: true,
                form: {
                    rfc: "",
                    numcli: "",
                    nomcli: "",
                    cp: "",
                    regimen: "",
                    uso: "G03",
                    email: ""
                },
                errRfc:false,
                errNomcli:false,
                errRegimen:false,
                errCp:false,
                errUso:false,
                errEmail:false
            }
        },
        mounted() {
            setTimeout(() => {
                this.$refs.txtrfc.focus()
            }, 400);

            if (!session.getValue("nota")) {
                this.$router.push({name: 'SearchNote'})
            } 

            if (session.getValue("cliente")) {
                this.loadData(session.getValue("cliente"))
            } 

        },
        computed: {
            ...mapGetters({
                client: 'client/getClient',
            })
        },
        methods: {
            toUppercase() {
                this.form.rfc = this.form.rfc.toUpperCase();
            },

            nomcliToUppercase() {
                this.form.nomcli = this.form.nomcli.toUpperCase();
            },

            loadData(data, closemodal) {
                if (closemodal) {
                    this.$bvModal.hide('modalListClients');
                }
                this.form.rfc = data.rfc;
                this.form.numcli = data.numcli;
                this.form.nomcli = data.nomcli;
                this.form.email = data.email;
                if (data.cp)
                    this.form.cp = data.cp;

                if (data.idregimen)
                    this.form.regimen = data.idregimen;

                if (data.usocfdi){
                    this.form.uso = data.usocfdi;
                }else{
                    this.form.uso = "G03"
                }

                if (data.numcli === "") {
                    this.isNewClient = true;
                } else {
                    this.isNewClient = false;
                    setTimeout(() => {
                        this.$refs.txtcp.focus();
                    }, 400);

                }

            },

            addNameClient(){
                this.$bvModal.hide('modalListClients');
                this.form.numcli = "";
                setTimeout(() => {
                    this.$refs.txtnomcli.focus()
                }, 400);
            },

            searchClient() {
                if (this.form.rfc.trim() === "") {
                    return
                }

                this.clearForm();

                let rfcFormatted = this.form.rfc.replace(/-/g, "").replace(/ /g, "")

                this.$store.dispatch('client/get', rfcFormatted).then(() => {
                    if (this.client.length > 1) {
                        this.$bvModal.show('modalListClients')
                    } else {
                        this.loadData(this.client[0]);
                    }
                }).catch((error) => {
                    this.isNewClient = true;
                    // this.msgConfirmCreateClient();
                    console.log(error.response.data.error)
                });
            },

            saveClient(e) {
                e.preventDefault();
                this.errRfc = false;
                this.errNomcli = false;
                this.errRegimen = false;
                this.errCp = false;
                this.errUso = false;
                this.errEmail = false;

                if (this.form.rfc.trim() === "" || this.form.nomcli.trim() === "" || this.form.uso.trim() === "" || this.form.cp.trim() === "" || this.form.regimen.trim() === "" || this.form.email.trim() === "") {

                    if(this.form.rfc.trim() ===""){
                        this.errRfc = true;
                    }

                    if(this.form.nomcli.trim() ===""){
                        this.errNomcli = true;
                    }
                    if(this.form.regimen.trim() ===""){
                        this.errRegimen = true;
                    }
                    if(this.form.cp.trim() ===""){
                        this.errCp = true;
                    }
                    if(this.form.uso.trim() ===""){
                        this.errUso = true;
                    }
                    if(this.form.email.trim() ===""){
                        this.errEmail = true;
                    }

                    this.msgAlert("Campos vacios", "Por Favor llene los campos antes de continuar");
                    return
                }

                this.form.rfc = this.form.rfc.toUpperCase().trim();
                this.form.nomcli = this.form.nomcli.toUpperCase().trim();
                this.form.cp = this.form.cp.trim();

                this.$store.dispatch('client/validateDataCustomer', this.form).then(() => {
                    if(this.isNewClient){
                        this.form.tipo="clievent"
                    }
                    session.setValue('cliente', this.form);
                    this.$router.push({name: 'CreateInvoice'})
                }).catch((error) => {
                   this.showValidarReceptorErrorMsg(error.codesat)                    
                });


               /* if (this.isNewClient) {
                    this.$store.dispatch('client/validateRfc', this.form.rfc).then(() => {
                        session.setValue('cliente', this.form);
                        this.$router.push({name: 'CreateInvoice'})
                    }).catch((error) => {
                        if (error.response.data.error) {
                            if(error.response.data.error.msg){
                                this.msgAlert('Ocurrió un problema al registrar cliente', error.response.data.error.msg);
                            }else{
                                this.msgAlert('Ocurrió un problema al registrar cliente', error.response.data.error);
                            }
                            console.log(error.response.data.error)
                        } else {
                            this.msgAlert(error.response.data.validations[0].error);
                            console.log(error.response.data.validations[0].error)
                        }
                    });
                } else {*/
                    //session.setValue('cliente', this.form);
                    //this.$router.push({name: 'CreateInvoice'})
                //}
            },

            msgConfirmCreateClient() {
                this.$bvModal.msgBoxConfirm('¿Desea registrar cliente?', {
                    title: 'RFC no encontrado',
                    size: 'sm',
                    buttonSize: 'sm',
                    okTitle: 'Crear',
                    cancelTitle: 'Cancelar',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true

                }).then(value => {
                    if (value) {
                        this.isNewClient = true;
                        setTimeout(() => {
                            this.$refs.txtnomcli.focus()
                        }, 400);
                    } else {
                        setTimeout(() => {
                            this.$refs.txtrfc.focus()
                        }, 400);
                    }
                });
            },

            msgAlert(title, err) {
                this.$bvModal.msgBoxOk(err, {
                    title: title,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                }).then(() => {
                    setTimeout(() => {
                        //this.$refs.txtrfc.focus()
                    }, 400);

                });
            },

            showValidarReceptorErrorMsg(codeSat) {
                let msg = "";

                const h = this.$createElement

                if(codeSat == "CFDI40999"){
                    msg = h('div',[
                        h('p', [h('b', 'RFC')]),
                        h('ul', [h('li', [h('b','EXACTAMENTE') ,' como aparece en la constancia SAT.'] )]),
                        h('p', [h('b', 'Nombre - Razón Social')]),
                        h('ul', [
                            h('li', [h('b','EXACTAMENTE') ,' como aparece en la constancia SAT.'] ),
                            h('li', 'Se debe omitir el régimen de la sociedad, como SA, SRL, SA CV, etc.' ),
                            h('li', 'Se debe incluir acentos solamente si en la constancia de situación fiscal aparece escrito' ),
                            h('li', 'No debe tener espacios de más entre palabras' ),
                        ]),
                        h('p', [h('b', 'Código Postal (DomicilioFiscalReceptor)')]),
                        h('ul', [h('li', [h('b','EXACTAMENTE') ,' como aparece en la constancia SAT.'] )]),
                        h('p', [h('b', 'Régimen Fiscal (RegimenFiscalReceptor)')]),
                        h('ul', [h('li', [h('b','EXACTAMENTE') ,' como aparece en la constancia SAT.'] )]),
                    ])
                }

                if(codeSat == "CFDI40143"){
                    msg = h('div',[
                        h('p', [h('b', 'RFC')]),
                        h('ul', [h('li', 'El RFC del receptor no esta en la lista del SAT.' )]),
                    ])
                }

                if(codeSat == "CFDI40144" || codeSat == "CFDI40145"){

                    msg = h('div',[
                        h('p', [h('b', 'Nombre - Razón Social')]),
                        h('ul', [
                            h('li', [h('b','EXACTAMENTE') ,' como aparece en la constancia SAT.'] ),
                            h('li', 'Se debe omitir el régimen de la sociedad, como SA, SRL, SA CV, etc.' ),
                            h('li', 'Se debe incluir acentos solamente si en la constancia de situación fiscal aparece escrito' ),
                            h('li', 'No debe tener espacios de más entre palabras' ),
                        ]),
                    ])
                } 

                if(codeSat == "CFDI40147" || codeSat == "CFDI40148" || codeSat == "CFDI40149"){
                    msg = h('div',[
                        h('p', [h('b', 'Código Postal (DomicilioFiscalReceptor)')]),
                        h('ul', [h('li', [h('b','EXACTAMENTE') ,' como aparece en la constancia SAT.'] )]),
                    ])
                }

                if(codeSat == "CFDI40157" || codeSat == "CFDI40158"){
                    msg = h('div',[
                        h('p', [h('b', 'Régimen Fiscal (RegimenFiscalReceptor)')]),
                        h('ul', [h('li', [h('b','EXACTAMENTE') ,' como aparece en la constancia SAT.'] )]),
                    ])
                }

                if(codeSat == "CFDI40159"){
                    msg = h('div',[
                        h('p', [h('b', 'Régimen Fiscal (RegimenFiscalReceptor)')]),
                        h('ul', [h('li', [h('b',"Si RFC es genérico(XAXX010101000) o Extranjero(XEXX010101000), el régimen debe ser '616 - Sin obligaciones fiscales'" )])]),
                    ])
                }

                this.$bvModal.msgBoxOk([msg], {
                    title: 'Sus datos fiscales no son correctos',
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                }).then(() => {
                });
            },


            clearForm() {
                this.form.numcli = "";
                this.form.nomcli = "";
                this.errRfc = false;
                this.errNomcli = false;
                this.errRegimen = false;
                this.errCp = false;
                this.errUso = false;
                this.errEmail = false;

                // this.isNewClient = false;
            }

        }

    }
</script>
<style>
    .client-pointer:hover {
        cursor: pointer;
        background-color: #f8f9fa;
    }
</style>